import {IAirBridge} from '../services/IAirBridge';
import {IWindowProxy} from '../services/IWindowProxy';
import {IPostAction} from './IPostAction';
import {NativePayAction} from './NativePayAction';
import {NativePriceAction} from './NativePriceAction';
import {NavigationLayoutAction} from './NavigationLayoutAction';
import {EmptyAction} from './EmptyAction';
import {ShopwebCheckoutAction} from './ShopwebCheckoutAction';
import {NativeSubscriptionsDialogAction} from './NativeSubscriptionsDialogAction';

export type RuntimeDeps = { windowProxy: IWindowProxy, searchParams: URLSearchParams };

export interface IActionFactory {
    create(eventName: string, deps: RuntimeDeps): IPostAction;
}

export class ActionFactory implements IActionFactory {
    constructor(private airBridge: IAirBridge) {
    }

    public create(eventName: string, deps: RuntimeDeps): IPostAction {
        switch (eventName) {
            case 'lemonstand.nativePay':
                return new NativePayAction(this.airBridge);
            case 'lemonstand.nativePrice':
                return new NativePriceAction(this.airBridge);
            case 'lemonstand.navigation.layout':
                return new NavigationLayoutAction(deps.windowProxy, deps.searchParams);
            case 'lemonstand.shopwebCheckout':
                return new ShopwebCheckoutAction(this.airBridge)
            case 'lemonstand.native.subscriptions.dialog':
                return new NativeSubscriptionsDialogAction(this.airBridge)

            default:
                return new EmptyAction();
        }
    }
}
